import baseApi from "./RootBaseApi";
import {
  ProductVatConfigCreatePayload,
  ProductVatConfigData,
  ProductVatConfigListResponse,
  ProductVatConfigQueryParams,
  ProductVatConfigUpdatePayload,
} from "@/types/product-vat-config.types";

export const ProductVatConfigService = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getProductVatConfigs: builder.query<
      ProductVatConfigListResponse,
      ProductVatConfigQueryParams | void
    >({
      query: (params) => ({
        url: "/product-vat-config",
        method: "GET",
        params,
      }),
      providesTags: ["ProductVatConfigs"],
    }),

    getProductVatConfigById: builder.query<ProductVatConfigData, string>({
      query: (id) => ({
        url: `/product-vat-config/${id}`,
        method: "GET",
      }),
      transformResponse: (response: { data: ProductVatConfigData }) =>
        response.data,
      providesTags: (result, error, id) => [{ type: "ProductVatConfigs", id }],
    }),

    createProductVatConfig: builder.mutation<
      ProductVatConfigData,
      ProductVatConfigCreatePayload
    >({
      query: (payload) => ({
        url: "/product-vat-config",
        method: "POST",
        data: payload,
      }),
      invalidatesTags: ["ProductVatConfigs"],
    }),

    updateProductVatConfig: builder.mutation<
      ProductVatConfigData,
      { id: string; payload: ProductVatConfigUpdatePayload }
    >({
      query: ({ id, payload }) => ({
        url: `/product-vat-config/${id}`,
        method: "PATCH",
        data: payload,
      }),
      invalidatesTags: (result, error, { id }) => [
        { type: "ProductVatConfigs", id },
        "ProductVatConfigs",
      ],
    }),

    deleteProductVatConfig: builder.mutation<void, string>({
      query: (id) => ({
        url: `/product-vat-config/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["ProductVatConfigs"],
    }),
  }),
});

export const {
  useGetProductVatConfigsQuery,
  useGetProductVatConfigByIdQuery,
  useCreateProductVatConfigMutation,
  useUpdateProductVatConfigMutation,
  useDeleteProductVatConfigMutation,
} = ProductVatConfigService;
